/*
 * Anagrama 2020
 * https://www.anagrama.com/
 * Version (2.0.0)
 */

/*
 * requires: 
 * Waypoints    - 4.0.1   - http://imakewebthings.com/waypoints/
 * Velocity     - 1.5.0   - http://velocityjs.org/
 * Velocity UI  - 5.0.4   - http://velocityjs.org/
 */

/*
 * <div class="fade-on-scroll">__<div>
 * ---
 * <div class="animate-on-scroll">__<div>
 * ---
 * <div class="stagger-on-scroll">
 *  <div class="stagger-child"></div>
 *  <div class="stagger-child"></div>
 * <div>
 */

NodeList.prototype.forEach = Array.prototype.forEach;

$(document).ready(function () {
  setTimeout(function () {
    setAnimationWaypoints()
  }, 1000);
});

function setAnimationWaypoints() {
  if (document.querySelector('.animate-on-scroll') || document.querySelector('.fade-on-scroll')) {
    var animateOnScroll = document.querySelectorAll('.animate-on-scroll, .fade-on-scroll');
    animateOnScroll.forEach(function (value, index) {
      var waypoint = new Waypoint({
        element: value,
        handler: function (direction) {
          if (direction == 'down') {
            var thisElement = this.element;
            thisElement.classList.add('animate');
            setTimeout(function () {
              thisElement.classList.remove('animate-on-scroll', 'fade-on-scroll', 'animate');
              waypoint.destroy()
            }, 3000);
          }
        },
        offset: '75%'
      })
    });
  }
  if (document.querySelector('.stagger-on-scroll:not(.animate)')) {
    var staggerOnScroll = document.querySelectorAll('.stagger-on-scroll:not(.animate)');
    staggerOnScroll.forEach(function (value, index) {
      var waypoint = new Waypoint({
        element: value,
        handler: function (direction) {
          if (direction == 'down' && !value.classList.contains('animated')) {
            var thisElement = this.element;
            value.classList.add('animated'); // Adding a flag class
            thisElement.classList.add('animate');
            var children = $(thisElement).find(".stagger-child")
            $(children).velocity("transition.slideUpIn", {
              stagger: 450,
              duration: 800,
              complete: function () {
                waypoint.destroy()
                $(this).css({ 'transform': '' });
              }
            })
          }
        },
        offset: '75%'
      })
    });
  }
  
  if (document.querySelector('.stagger-fast-on-scroll')) {
    var staggerOnScroll = document.querySelectorAll('.stagger-fast-on-scroll');
    staggerOnScroll.forEach(function (value, index) {
      var waypoint = new Waypoint({
        element: value,
        handler: function (direction) {
          if (direction == 'down') {
            var thisElement = this.element;
            thisElement.classList.add('animate');
            var children = $(thisElement).find(".stagger-child")
            $(children).velocity("transition.slideUpIn", {
              stagger: 250,
              duration: 800,
              complete: function () {
                waypoint.destroy()
                $(this).css({ 'transform': '' });
              }
            })
          }
        },
        offset: '75%'
      })
    });
  }
  if(document.querySelector('.hotspot-on-scroll')) {
    console.log('hotspot-on-scroll')
    var hotOnScroll = document.querySelectorAll('.hotspot-on-scroll');
    hotOnScroll.forEach(function (value, index) {
      var waypoint = new Waypoint({
        element: value,
        handler: function (direction) {
          if (direction == 'down') {
            var thisElement = this.element;
            thisElement.classList.add('animate');
          }
        },
        offset: '75%'
      })
    });
  }
  if (document.querySelector('.blast-on-scroll')) {
    var blastOnScroll = document.querySelectorAll('.blast-on-scroll');
    blastOnScroll.forEach(function (value, index) {
      $(value).blast()
      var waypoint = new Waypoint({
        element: value,
        handler: function (direction) {
          if (direction == 'down') {
            var thisElement = this.element;
            thisElement.classList.add('animate');
            var children = $(thisElement).find(".blast")
            $(children).velocity("transition.fadeIn", {
              stagger: 150,
            })
          }
        },
        offset: '75%'
      })
    });
  }
}

// Function to check if an element's bottom is in the viewport
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.bottom >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

// Function to handle scroll event for all boxes
function handleScroll() {
  const boxes = document.querySelectorAll('.simplefade');
  boxes.forEach(box => {
    if (isInViewport(box)) {
      box.style.opacity = 1; // Change opacity to 1 if in viewport
    }
  });
}

// Attach scroll event listener only if the device is a computer
if (window.innerWidth > 990) { // Change 768 to the desired threshold for computer screens
  document.addEventListener('scroll', handleScroll);

  // Initial check when page loads
  handleScroll();
}
